// extracted by mini-css-extract-plugin
export default {"selectReadOnly":"TargetOsSelector_selectReadOnly__swF6s","select":"TargetOsSelector_select__arrTP"};